module.exports = __webpack_public_path__ + "img/favourite.1b09cc5f.svg";